<template>
  <WdsText
    class="tw-whitespace-nowrap"
    :secondary="!assignedAt"
    :text="assignedAt ? date : '—'"
    :data-test="`owner-assigned-at-${rowIndex}`"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import useDate from '@/composables/useDate'

const OwnerAssignedAtColumn = graphql(`
  fragment OwnerAssignedAtColumn on Owner {
    id
    assignedAt
  }
`)

const props = defineProps<{
  row: FragmentType<typeof OwnerAssignedAtColumn>
  rowIndex?: number
}>()

const assignedAt = computed(() => useFragment(OwnerAssignedAtColumn, props.row).assignedAt ?? null)
// useDate(null) would render today; the template shows a dash instead.
const { date } = useDate(computed(() => assignedAt.value ?? ''))
const rowIndex = computed(() => props.rowIndex ?? 0)
</script>
